export const LIST_REFERRALS = 'LIST_REFERRALS';
export const LIST_EXPORT_REFERRALS = 'LIST_EXPORT_REFERRALS';